import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ServiceSettingsRoutingModule } from './service-settings-routing.module';
import { ServiceSettingsComponent } from './service-settings.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [ServiceSettingsComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    ServiceSettingsRoutingModule
  ],
  exports:[TranslateModule]
})
export class ServiceSettingsModule { }
